<template>
  <div class="select-auth-type-content">
    <img class="body-logo" alt="Logo" src="../assets/o-logo.png" />
    <div class="h2">Добро пожаловать в РосДорБанк!</div>
    <div class="h2">3 шага для открытия счета:</div>
    <img class="steps-img" alt="steps" src="../assets/steps.png" />
    <div class="body-buttons">
      <button @click="openNextPage(true)">
        Войти с использованием электронной цифровой подписи* (ЭЦП)
      </button>
      <button @click="openNextPage(false)">
        Войти без электронной цифровой подписи* (ЭЦП)
      </button>
    </div>
    <div class="h3">
      * Электронная цифровая подпись, оформленная в удостоверяющем центре,
      имеющем аккредитацию Минкомсвязи
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthSelectPage",
  methods: {
    openNextPage(withDigitalKey) {
      this.$emit("openNextPage", withDigitalKey);
    },
  },
};
</script>

<style scoped>
button {
  font-size: 13pt;
  color: white;
  background-color: #1e3e88;
  width: 300px;
  height: 150px;
  border: 0px;
  margin: 0 auto;
  padding: 0 15px;
  border-radius: 10px;
  border: 5px white solid;
  cursor: pointer;
  text-align: center;
}
.select-auth-type-content {
  display: flex;
  flex-direction: column;
}
.body-logo {
  margin: 30px auto;
}
.steps-img {
  height: 400px;
  margin: 30px auto;
}
button:hover {
  background-color: #145d9c;
}
.body-buttons {
  width: 60%;
  display: inline-flex;
  flex-direction: row;
  margin: 0 auto;
}
.h2 {
  text-align: center;
  font-size: 22pt;
  font-weight: bold;
  padding-bottom: 5px;
  color: #1e3e88;
}
.h3 {
  text-align: center;
  font-size: 14pt;
  padding-top: 30px;
  color: #1e3e88;
}
</style>
